import React from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { MAX_LICENSES } from "./quoteOptions";
import "./QuoteForm.css";

// How many seats. Clamped rather than validated: there is no way to type an
// out-of-range number, so there is no error state to report.
export default function QuantityStepper({ value, onChange, max = MAX_LICENSES, min = 1 }) {
  const setTo = (next) => onChange(Math.min(max, Math.max(min, next)));

  return (
    <div className="quantity-stepper">
      <button type="button" onClick={() => setTo(value - 1)} disabled={value <= min} aria-label="Fewer licenses">
        <FaMinus size={11} />
      </button>
      <span>{value}</span>
      <button type="button" onClick={() => setTo(value + 1)} disabled={value >= max} aria-label="More licenses">
        <FaPlus size={11} />
      </button>
    </div>
  );
}
